import { Pipe, PipeTransform } from '@angular/core';
import { TableColumn } from '../models/table-column';

@Pipe({ name: 'tableColumnValue' })
export class TableColumnValuePipe implements PipeTransform {
  transform<T>(column: TableColumn<T> | null, rowData: T): string {
    if (!column || !column.value) return '';
    return column.value(rowData) ?? '';
  }
}
